module.exports = __webpack_public_path__ + "static/img/solution.c4a4570.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/solution/solution.jpg
// module id = CKee
// module chunks = 1